import { createPerfilApiClient } from './perfilApiClient';

export default {
    /**
     * Obtiene los datos personales del perfil del usuario autenticado.
     * Devuelve los datos tal como los entrega el backend, sin normalización.
     *
     * @param {string} hashTeatro - hash del teatro en curso
     * @returns {Promise<Object>} datos crudos del backend
     */
    async getDatosPersonales(hashTeatro) {
        try {
            const params = hashTeatro ? `?tid=${hashTeatro}&api_key=${localStorage.getItem('token')}` : '';
            const response = await createPerfilApiClient().get(`/f/perfilV2${params}`);
            return response.data?.datos ?? response.data?.data ?? response.data ?? {};
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[datosPersonales] Error al obtener perfil:', error);
            }
            throw error;
        }
    },

    /**
     * Actualiza los datos personales del usuario autenticado.
     * Devuelve la respuesta del backend sin normalización.
     *
     * @param {string} hashTeatro - hash del teatro en curso
     * @param {Object} payload - campos a actualizar
     * @returns {Promise<Object>} respuesta cruda del backend
     */
    async updateDatosPersonales(hashTeatro, payload) {
        try {
            const token = localStorage.getItem('token');

            const data = {
                tid: hashTeatro,
                ...payload,
            };

            const response = await createPerfilApiClient().put('/f/perfilV2', data, {
                params: {
                    tid: hashTeatro,
                    api_key: token,
                },
            });

            return response.data?.datos ?? response.data?.data ?? response.data ?? {};
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[datosPersonales] Error al actualizar perfil:', error);
            }
            throw error;
        }
    },
};
